/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_ImpersonatingInputs */



/**
* | output |
* | --- |
* | "You are viewing this conversation as someone else. You cannot write in it." |
*
* @param {Chat_ImpersonatingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_impersonating = /** @type {((inputs?: Chat_ImpersonatingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_ImpersonatingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je bekijkt dit gesprek als iemand anders. Meeschrijven kan niet.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous consultez cette conversation sous l'identité d'une autre personne. Vous ne pouvez pas y écrire.")
	return /** @type {LocalizedString} */ ("You are viewing this conversation as someone else. You cannot write in it.")
});